"use client";
import { useState } from "react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if (res.ok) { window.location.href = "/fulfillment"; return; }
    const j = await res.json();
    setError(j?.error?.message ?? "Ошибка входа");
  }

  return (
    <main
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
      }}
    >
      <div
        className="card"
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "clamp(28px, 5vw, 44px)",
          boxShadow: "var(--shadow)",
        }}
      >
        {/* Brand block — mono eyebrow · Prata wordmark · brass rule · lede */}
        <div style={{ textAlign: "center" }}>
          <div className="eyebrow" style={{ color: "var(--brassbr)", letterSpacing: ".18em" }}>
            Бэк-офис · Персонал
          </div>
          <h1
            className="display"
            style={{
              fontSize: "clamp(38px, 8vw, 48px)",
              lineHeight: 1,
              color: "var(--brassbr)",
              margin: "14px 0 0",
            }}
          >
            Бриолин
          </h1>
          <div
            style={{ width: "56px", height: "2px", background: "var(--brass)", margin: "18px auto" }}
          />
          <p
            className="muted"
            style={{ font: "400 14px/1.5 var(--font-body)", margin: 0 }}
          >
            Вход для персонала
          </p>
        </div>

        <form
          onSubmit={submit}
          aria-label="Вход для персонала"
          style={{ marginTop: "28px", display: "flex", flexDirection: "column", gap: "6px" }}
        >
          <label htmlFor="email" className="eyebrow" style={{ color: "var(--brassbr)" }}>
            Логин
          </label>
          <input
            id="email"
            className="field"
            type="text"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", color: "var(--ink)", marginBottom: "10px" }}
          />
          <label htmlFor="password" className="eyebrow" style={{ color: "var(--brassbr)" }}>
            Пароль
          </label>
          <input
            id="password"
            className="field"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", color: "var(--ink)" }}
          />
          <button
            type="submit"
            className="btn-p"
            style={{ width: "100%", marginTop: "12px", padding: "13px 18px" }}
          >
            Войти
          </button>
        </form>

        {error && (
          <p
            role="alert"
            className="s-err"
            style={{
              marginTop: "14px",
              marginBottom: 0,
              padding: "11px 14px",
              borderRadius: "5px",
              font: "500 13px var(--font-body)",
            }}
          >
            {error}
          </p>
        )}
      </div>
    </main>
  );
}
